import React, { useEffect, useState } from 'react';
import { Box, Typography, Button, Paper, Chip, } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { ChevronLeft, User } from 'react-feather';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux'
import Toastmessage from '../../components/Toast';
import { logout } from '../../features/auth/AuthSlice';
import { useSelector } from 'react-redux';
import { authApi } from '../../api/api';
import dayjs from 'dayjs';

export default function ViewBonus() {
    const location = useLocation();
    const dispatch = useDispatch()
    const navigate = useNavigate();
    const userID = useSelector((state_id) => state_id.auth.id);
    const token = useSelector((state_id) => state_id.auth.token);
    const { bonusId } = location.state || {};
    const [formData, setFormData] = useState({
        id: '',
        bonus: '',
        startdate:'',
        enddate:"",
        designation_name: '',
        extra_bonus: '',
        status: '',
    });

    useEffect(() => {
        if (bonusId) {
            viewBonus(bonusId)
        }
    }, [bonusId])

    const handleClickEdit = () => {
        navigate('/editbonus', { state: { bonusId: bonusId } });
    };
    const handleBack = () => {
        setTimeout(() => navigate('/bonus'));
    };

    const viewBonus = async (bonusId) => {
        const input_token = `${bonusId}BONUS_DETAIL`;
        const apiUrl = 'view_bonus'; // Replace with the actual API endpoint

        const dataInput = {
            login_user_id: userID,
            bonus_id: bonusId,
        };
        try {
            const data = await authApi(input_token, dataInput, apiUrl, token);

            if (data && data.success) {
                setFormData(prevState => ({
                    ...prevState,
                    id: data.bonus_detail.id,
                    bonus: data.bonus_detail.bonus,
                    designation_name: data.bonus_detail.user_detail.full_name,
                    extra_bonus: data.bonus_detail.extra_bonus,
                    startdate:dayjs(data.bonus_detail.duration_start_date).format("MM/DD/YYYY"),
                    enddate:dayjs(data.bonus_detail.duration_end_date).format("MM/DD/YYYY"),
                    isActive: !!data.bonus_detail.status,
                }));
                
            } else if (data && data.message === 'Token has expired') {
                dispatch(logout());
                localStorage.removeItem('token');
                navigate('/login');
            } else if (data === undefined) {
                await Toastmessage('No response from server', false);
            } else {
                await Toastmessage(data?.message || 'An error occurred', false);
            }

        } catch (error) {
            console.error("Error fetching data:", error);
            if (error.response && error.response.status === 401) {
                dispatch(logout());
                localStorage.removeItem('token');
                await Toastmessage('Session expired. Redirecting to login...', false);
                navigate('/login');
            } else {
                await Toastmessage('Something went wrong', false);
            }
        }
    }

    return (
        <Box>
            <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                marginBottom='20px'
                backgroundColor='var(--theme-bg-light)'
                padding={2}
                borderRadius={1}
            >
                {/* Left Section */}
                <Box display="flex" alignItems="center">
                    <User style={{ marginRight: 8, fontSize: '12px', color: 'var(--icon-color)' }} />
                    <Typography fontSize={12} color="var(--text-color)">
                        View Bonus
                    </Typography>
                </Box>

                {/* Right Section */}
                <Button
                    variant="outlined"
                    component={Link}
                    to="/designation"
                    sx={{
                        backgroundColor: 'var(--back-button)',
                        color: "var(--back-color)",
                        fontWeight: 'bold',
                        border: 'none',
                        padding: '10px 20px'
                    }}
                    startIcon={<ChevronLeft sx={{ fontSize: 17 }} />}
                    style={{ textTransform: 'none' }}
                >
                    Back to Bonus List
                </Button>
            </Box>

            <Box className="card-box" sx={{ p: { xs: 2, sm: 2, md: 3 }, m: { xs: 1, sm: 2, md: 3 }, border: '1px solid var(--border-color)', borderRadius: '8px' }}>
                <Box className="sub-header">
                    <Typography sx={{ color: '#3570FF', fontSize: '14px', fontWeight: 'bold' }}>
                        View Bonus
                    </Typography>
                    <Typography
                        sx={{ fontWeight: 'bold' }}
                    >
                        Account status: <span sx={{ color: formData.isActive ? 'green' : 'red', backgroundColor: formData.isActive ? 'transparent' : 'red', display: 'inline-block', fontWeight: 'bold' }}>{formData.isActive ? 'Yes' : 'No'}</span>
                    </Typography>
                </Box>


                <Box >
                    <Grid container spacing={6}>
                        <Grid size={4}>
                            <Typography sx={{ color: '#595A63', fontSize: '14px', marginBottom: '8px' }}>User Name :</Typography>
                            <Typography sx={{ fontSize: '16px', color: '#595A63' }}>{formData.designation_name}</Typography>
                        </Grid>
                        <Grid size={4}>
                            <Typography sx={{ color: '#595A63', fontSize: '14px', marginBottom: '8px' }}>From Date :</Typography>
                            <Typography sx={{ fontSize: '16px', color: '#595A63' }}>{formData.startdate}</Typography>
                        </Grid>
                        <Grid size={4}>
                            <Typography sx={{ color: '#595A63', fontSize: '14px', marginBottom: '8px' }}>To Date :</Typography>
                            <Typography sx={{ fontSize: '16px', color: '#595A63' }}>{formData.enddate}</Typography>
                        </Grid>
                        <Grid size={3}>
                            <Typography sx={{ color: '#595A63', fontSize: '14px', marginBottom: '8px' }}>Monthly Bonus Amount($):</Typography>
                            <Typography sx={{ fontSize: '16px', color: '#595A63' }}>${formData.bonus}</Typography>
                        </Grid>
                        <Grid size={3}>
                            <Typography sx={{ color: '#595A63', fontSize: '14px', marginBottom: '8px' }}>Extra Bonus Percentage :</Typography>
                            <Typography sx={{ fontSize: '16px', color: '#595A63' }}>{formData.extra_bonus}%</Typography>
                        </Grid>
                    </Grid>

                    {/* Action Buttons */}
                    <Box display={'flex'} justifyContent={'center'} gap={2} mt={4}>
                        <Button variant="contained" color="primary" onClick={() => handleClickEdit()}
                            sx={{ padding: '15px 30px', borderRadius: "8px", fontWeight: 'bold', backgroundColor: 'var(--primary-color)', color: '#fff', '&:hover': { backgroundColor: 'var(--primary-color)' } }}

                        >Edit Bonus Details</Button>
                        <Button variant="outlined" onClick={() => handleBack()}
                            sx={{ padding: '15px 30px', borderRadius: "8px", fontWeight: 'bold', backgroundColor: 'var(--back-button)',
                                color: "var(--back-color)", '&:hover': { backgroundColor: 'var(--primary-color)', color: '#fff' } }}
                        ><ChevronLeft size={24} /> Back to Bonus list</Button>
                    </Box>
                </Box>
            </Box>
        </Box>
    );
}
